export default __webpack_public_path__ + "static/media/rc-team.50a874ac.png";